"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiChooserState = void 0;
const input_state_1 = require("../../components/input/input.state");
class MultiChooserState extends input_state_1.InputState {
    get groups() {
        return this._groups;
    }
    set groups(value) {
        this._groups = value;
    }
    constructor(label) {
        super(label);
        this.readOnly = true;
    }
    get displayValue() {
        return this._displayValue;
    }
    set displayValue(value) {
        this._displayValue = value;
    }
    getAllOptions() {
        let allOptions = [];
        //we only keep the last selected node. If intermediate nodes are important, this function needs to be overwritten (see NestedListChooserState)
        for (let group of this.groups) {
            for (let item of group.items) {
                allOptions.push([item]);
            }
        }
        return allOptions;
    }
}
exports.MultiChooserState = MultiChooserState;
//# sourceMappingURL=multi.list.chooser.state.js.map